<div class="widget-container" #wordCloud>
    <app-scatter-chart
    style="width: 100%;"
    [config]="config"
    [headerConfig]="this.item.config.widget_header_config"
    [heading]="heading" 
    [data]="data"  
    [item]="item"
    [pageKey]="pageKey"
    [error_name]="error_name"
    (showBychanges)="showByChanges($event)"
    ></app-scatter-chart>
</div>

<!-- style="width: 100%;"
[config]="config"
[headerConfig]="this.item.config.widget_header_config"
[heading]="heading" 
[data]="data"  
[item]="item"
[pageKey]="pageKey"
[error_name]="error_name" -->